import { RcThemeInput } from '@ringcentral/juno';
import { overridesFactory } from '@/shared/theme/utils/overrides.factory';
import { paletteFactory } from '@/shared/theme/utils/palette.factory';

export const attColor = '#0A6EBE';

export const attTheme: RcThemeInput = {
  palette: paletteFactory(attColor),
  overrides: overridesFactory(attColor),
};
